export default {
    data() {
        return {
            table: "admin",
            datas: {
                append: ['group'],
                order: 'id asc'
            },
            groups: [],
            user_groups: []
        };
    },
    created() {
        this._load();
        this._groups();
    },
    methods: {
        _groups() {
            this.$http.post('admin_group/list').then(res => {
                this.groups = res.data.data;
            })
        }
    },
};